<main class="em-l-container main-content">
  <div *ngIf="isLoading">
    <app-loader></app-loader>
  </div>

  <div *ngIf="!isLoading">
    <!-- Breadcrumbs -->
    <supplier-breadcrumbs [items]="breadcrumbItems"></supplier-breadcrumbs>

    <fieldset class="em-c-fieldset">
      <legend class="em-c-fieldset__legend">Create New Supplier Profile</legend>
      <div class="em-l-grid em-l-grid--2up">
        <!-- Supplier Identity -->
        <div class="em-l-grid__item">
          <div
            class="em-c-field"
            [ngClass]="{ 'em-has-error': validationError.supplierIdentity }"
          >
            <label for="" class="em-c-field__label">Supplier Identity</label>
            <div class="em-c-field__body">
              <input
                [(ngModel)]="supplierIdentity"
                class="em-c-input em-js-input"
                oninput="this.value = this.value.toUpperCase()"
                (keydown.space)="$event.preventDefault()"
                (change)="validationError.supplierIdentity = ''"
              />
            </div>
            <div
              class="em-c-field__note"
              *ngIf="!validationError.supplierIdentity"
            >
              How would you wanted to call this new supplier. eg. BASF
            </div>
            <div
              class="em-c-field__note"
              *ngIf="validationError.supplierIdentity"
            >
              {{ validationError.supplierIdentity }}
            </div>
          </div>
        </div>
        <!-- Supplier Description -->
        <div class="em-l-grid__item">
          <div class="em-c-field">
            <label for="" class="em-c-field__label">Supplier Description</label>
            <div class="em-c-field__body">
              <input
                [(ngModel)]="supplierName"
                class="em-c-input em-js-input"
              />
            </div>
            <div class="em-c-field__note">
              More description. eg. BASF Coporation
            </div>
          </div>
        </div>
        <!-- Plant -->
        <div class="em-l-grid__item">
          <plant-input
            [(selectedValue)]="plant"
            (selectedValueChange)="validationError.plant = ''"
            [error]="validationError.plant"
          ></plant-input>
        </div>
        <!-- Vendor -->
        <div class="em-l-grid__item">
          <vendor-input
            [(selectedValue)]="vendor"
            (selectedValueChange)="validationError.vendor = ''"
            [error]="validationError.vendor"
          ></vendor-input>
        </div>
      </div>
    </fieldset>

    <h4>Exceptions</h4>
    <exception-table
      [isViewOnly]="false"
      (saveException)="handleSaveException($event)"
      (validateSupplierProfile)="checkValidation($event)"
    >
    </exception-table>
  </div>
</main>
